module.exports = __webpack_public_path__ + "img/m3sketch.b053a16e.png";